module.exports = __webpack_public_path__ + "221881c20e4937777aeb7f1d822a6a24.svg";